import { clsx } from 'clsx'
import * as React from 'react'
import { useRepoStore } from '../../../(editor)/explore/components/repo-store'

export const DiffBlockWrapper: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLElement>>
> = ({ className, children, id, ...rest }) => {
  const setFocus = useRepoStore((s) => s.setFocus)
  const isFocused_type = useRepoStore((s) =>
    s.focus?.blockId === id ? s.focus?.type : null
  )
  const contentRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!isFocused_type) return

    if (isFocused_type === 'block:wrapper') {
      const blockWrapperEl = contentRef.current
      if (blockWrapperEl) {
        setFocus(null)
        blockWrapperEl.focus()
        setTimeout(
          () => blockWrapperEl.scrollIntoView({ block: 'center' }),
          100
        )
      }
    }
  }, [id, isFocused_type, setFocus])

  const amountOfChildren = React.Children.count(children)

  return (
    <div
      {...rest}
      ref={contentRef}
      className={clsx(
        'grid gap-y-2 items-start relative z-40 grid-cols-[100%]',
        amountOfChildren > 1 ? 'grid-rows-[min-content_1fr]' : 'grid-rows-1',
        className
      )}
    >
      {children}
    </div>
  )
}
